import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/notificationConfigurations'
import { BsrsGrid } from '@/components/BsrsGrid'
import { GridColumn as Column, GridCell } from '@progress/kendo-react-grid'
import { WhiteBox } from '@/components/Layout'
import context from '@/context'
import Resx from '@/components/Resx'
import { useLocalization } from '@/hooks/localization'
import { CustomInput } from 'reactstrap'

const checkboxCell = (props) => {
  return class CheckBoxCell extends GridCell {
    handleOnChange = (e) => {
      const { dataItem, field } = this.props
      props.onChange({ ...dataItem, [field]: e.target.checked })
    }
    render () {
      const value = this.props.dataItem[this.props.field]
      const id = `${this.props.dataItem.notificationType}_${this.props.field}`
      return (
        <td className='notification-settings-checkbox-cell'>
          <CustomInput type='checkbox' id={id} checked={value} value={value} onChange={this.handleOnChange} />
        </td>
      )
    }
  }
}

const notificationTypeCell = (props) => {
  return class NotificationTypeCell extends GridCell {
    render () {
      const value = this.props.dataItem[this.props.field]
      return <td>{props.localize(`NotificationsNames.${value}`)}</td>
    }
  }
}

const NotificationConfigurations = (props) => {
  const { localize } = useLocalization()
  const { get } = props
  useEffect(() => {
    get(context.isInternalApp() ? 0 : 1)
  }, [get])

  const { fetching, updating, items, isSmsEnabled } = props.notificationConfigurations
  const loading = fetching || updating
  const columns = [
    <Column key='notificationType' field='notificationType' title={localize('UserProfile.Type')} cell={notificationTypeCell({ localize })} width='350px' />,
    <Column key='email' field='email' title={localize('UserProfile.Email')} cell={checkboxCell({ onChange: props.update })} width='150px' />
  ]
  if (isSmsEnabled) { columns.push(<Column key='sms' field='sms' title={localize('UserProfile.SMS')} cell={checkboxCell({ onChange: props.update })} width='150px' />) }
  return (
    <WhiteBox
      className=''
      header={<Resx name='UserProfile.NotificationSettings' />}>
      <BsrsGrid items={items} loading={loading} simpleView>
        {columns}
      </BsrsGrid>
    </WhiteBox>
  )
}

const mapDispatchToProps = {
  get: actionCreators.get,
  update: actionCreators.update
}

export default connect(({ notificationConfigurations }) => ({ notificationConfigurations }), mapDispatchToProps)(NotificationConfigurations)



// WEBPACK FOOTER //
// ./src/components/userProfile/notificationConfigurations/index.js